import _ from "lodash";
import { eLynxObjectTypeEnum } from "../../common/enums/eLynxObjectType";
import i18n from "../../services/localization-service/i18n";
import { IEditDTO, IEditTagDTO, ISummaryUsageDTO } from "../../services/setpoint-administration-service/Models";
import { ActionMenuItem, BaseActions } from "../action-menu/ActionMenuItem";

export enum SetPointTestDisableActionEnum {
    Test = 'test',
    Disable = 'disable'
}

export type SetPointTestDisableListActionItem = {
    action: SetPointTestDisableActionEnum | BaseActions
} & ActionMenuItem;


export const actionItems: SetPointTestDisableListActionItem[] = [{
        label: i18n.t("setpointAdmin.actions.disable"),
        action: SetPointTestDisableActionEnum.Disable,
        // onClick: () => {
        //     onAction(SetPointTestDisableActionEnum.Disable, item);
        // },
    }, {
        label: i18n.t("setpointAdmin.actions.test"),
        action: SetPointTestDisableActionEnum.Test,
        // onClick: () => {
        //     onAction(SetPointTestDisableActionEnum.Test, item);
        // },
}];
 

export type AlarmSetpointTestDisableFormValuesType = {

    devices: ISummaryUsageDTO[];
    tanks: ISummaryUsageDTO[];
    tankBatteries: ISummaryUsageDTO[];
    wells: ISummaryUsageDTO[];
};

export const defaultFormValues: AlarmSetpointTestDisableFormValuesType = {
    devices: [],
    tanks: [],
    tankBatteries: [],
    wells: []
};


const updateUsageItem = (usage: ISummaryUsageDTO[], tags: IEditTagDTO[]) => {

    usage.forEach(o => {
        const tag = tags.find(v => v.tagID === o.tagID);

        if (tag) {
            o.notifyOnAlarm = tag.notifyOnAlarm;
            o.notifyOnNormal = tag.notifyOnNormal
        }
    });


}

const AlarmSetpointTestDisableUtils = {



    mapToFormValues: (setpoint: IEditDTO, usageData: ISummaryUsageDTO[]
    ): AlarmSetpointTestDisableFormValuesType  => {


        const deviceUsage = _.cloneDeep(usageData?.filter(o => o.tagObjectTypeID === eLynxObjectTypeEnum.Device) ?? []);
        if (deviceUsage.length > 0) {
            updateUsageItem(deviceUsage, setpoint.tags);
        }
        
        const tankUsage = usageData?.filter(o => o.tagObjectTypeID === eLynxObjectTypeEnum.Tank) ?? [];
        if (tankUsage.length > 0) {
            updateUsageItem(tankUsage, setpoint.tags);
        }

        const tankBatteryUsage = usageData?.filter(o => o.tagObjectTypeID === eLynxObjectTypeEnum.TankBattery) ?? [];
        if (tankBatteryUsage.length > 0) {
            updateUsageItem(tankBatteryUsage, setpoint.tags);
        }
        
        const wellUsage = usageData?.filter(o => o.tagObjectTypeID === eLynxObjectTypeEnum.Well) ?? [];
        if (wellUsage.length > 0) {
            updateUsageItem(wellUsage, setpoint.tags);
        }
        
        return ({
            devices: deviceUsage,
            wells: wellUsage,
            tanks: tankUsage,
            tankBatteries: tankBatteryUsage
        });
    }
};

export default AlarmSetpointTestDisableUtils;
